import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

const CustomItemDialog = ({
  open,
  onOpenChange,
  customItem,
  onCustomItemChange,
  onAddCustomItem,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl uppercase tracking-tight text-[#00341d]">Add Custom Line Item</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label>Service Name *</Label>
            <Input 
              value={customItem.service_name} 
              onChange={(e) => onCustomItemChange({ ...customItem, service_name: e.target.value })} 
              placeholder="e.g., Tree Removal" 
              className="mt-1" 
              data-testid="custom-item-name" 
            />
          </div>
          <div>
            <Label>Description</Label>
            <Textarea 
              value={customItem.description} 
              onChange={(e) => onCustomItemChange({ ...customItem, description: e.target.value })} 
              placeholder="Describe the service..." 
              className="mt-1" 
              rows={3} 
            />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <Label>Quantity</Label>
              <Input 
                type="number" 
                step="0.1" 
                value={customItem.quantity} 
                onChange={(e) => onCustomItemChange({ ...customItem, quantity: parseFloat(e.target.value) || 1 })} 
                className="mt-1" 
              />
            </div>
            <div>
              <Label>Unit</Label>
              <Input 
                value={customItem.unit} 
                onChange={(e) => onCustomItemChange({ ...customItem, unit: e.target.value })} 
                placeholder="each" 
                className="mt-1" 
              />
            </div>
            <div>
              <Label>Price ($)</Label>
              <Input 
                type="number" 
                step="0.01" 
                value={customItem.unit_price} 
                onChange={(e) => onCustomItemChange({ ...customItem, unit_price: parseFloat(e.target.value) || 0 })} 
                className="mt-1" 
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onAddCustomItem} className="bg-[#00341d] hover:bg-[#002816]" data-testid="add-custom-item-button">Add Item</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomItemDialog;
